/**
 * Céu da /camping de acordo com a hora LOCAL do visitante (2026-10-07).
 *
 * O sol nasce baixo à esquerda às 5h, sobe em arco até o meio-dia e se põe à
 * direita às 19h. Das 19h às 5h vira lua, no mesmo arco. Cada período troca a
 * paleta do céu (sempre pastel — o texto escuro precisa continuar legível).
 *
 * POR QUE ISTO PRECISA SER AUTOCONTIDO
 *
 * A página é gerada estática no build, sem hora. Se o cálculo rodasse só no
 * React, o visitante veria o sol "padrão" e depois o veria pular de lugar. Então
 * a função vai SERIALIZADA (Function.prototype.toString) para um <script> no
 * <head>, que roda antes da primeira pintura. Para isso funcionar ela não pode
 * referenciar nada de fora: nem import, nem constante do módulo — só globais do
 * navegador (document, location, URLSearchParams, Math).
 *
 * Para conferir os quatro períodos sem esperar o relógio: /camping/?hora=21
 * (aceita também 21:30).
 */
export function aplicarCeu(raiz: HTMLElement, agora: Date): void {
  let h = agora.getHours() + agora.getMinutes() / 60;
  const forcada = new URLSearchParams(location.search).get("hora");
  if (forcada) {
    const [hh, mm] = forcada.split(":");
    const n = Number(hh) + (Number(mm) || 0) / 60;
    if (n >= 0 && 24 > n) h = n;
  }

  const periodo =
    h >= 19 || 5 > h ? "noite" : 8 > h ? "amanhecer" : h >= 16 ? "entardecer" : "dia";

  // Progresso no arco: 0 = nascendo (esquerda) · 1 = se pondo (direita).
  // Altura: 0 no horizonte, 1 no ponto mais alto (meio-dia / meia-noite).
  // A GEOMETRIA (onde fica o horizonte, quão alto sobe) é do CSS, porque muda
  // com a tela: no celular o astro anda numa faixa de céu acima do mascote; no
  // desktop o arco é largo e nasce rente aos morros. Ver .camping-astro.
  const p = periodo === "noite" ? ((h - 19 + 24) % 24) / 10 : (h - 5) / 14;
  const altura = Math.sin(p * Math.PI);

  raiz.setAttribute("data-periodo", periodo);
  raiz.style.setProperty("--astro-p", p.toFixed(3));
  raiz.style.setProperty("--astro-alt", altura.toFixed(3));

  // Barra do navegador no celular acompanha o topo do céu
  const topoDoCeu: Record<string, string> = {
    amanhecer: "#f6e1da",
    dia: "#eef3e6",
    entardecer: "#f8dcc8",
    noite: "#e3e5f1",
  };
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", topoDoCeu[periodo]);
}
